export default __webpack_public_path__ + "b8f275e215270c44175ecc7254a2a5ca.svg";